import { http } from "./httpService";
import Logger from "../utils/logger";
import { dataService } from "./dataService";
import {
  // CaptchaRequest,
  LoginRequest,
  LoginResponse,
  RefreshTokenResponse,
  // RejectSignUpRequest,
  // SignUp,
  // SignUpRequest,
  // SignUpRequestFilter,
} from "../models/login.model";
import { Role, UiMode } from "../models/static.model";
import { RcmdResponseHeader } from "../models/rcmd-response.model";
import { RcmdEmptyBody } from "../models/rcmd-response.model";
import { config } from "../utils/config";
import { AuthToken, EmptyToken, JwtToken } from "../models/token.model";
import history from "../utils/history";
import { PagedResult } from "../models/profile.models";
import { el, ro } from "date-fns/locale";
import { AxiosRequestConfig, Method, AxiosResponse } from "axios";
import { responseValidator } from "./responseValidator";
import { RcmdResponse, RcmdResponseBody } from "../models/rcmd-response.model";


import { WEB_VIEW_ERROR_PATH, } from "../components/Routes/var_PATHS";
import { httpClient } from "./httpClient";

class AuthService {
  private logger = new Logger(this.constructor.name);

  getLoginUrl(): Promise<LoginResponse> {
    const path = `${config.beBaseUrl}/api/v1/login`;
    const loginRequest: LoginRequest = new LoginRequest(
      config.feBaseUrl + config.loginSuccessPath,
      config.feBaseUrl + config.loginCancelPath,
      config.feBaseUrl + config.loginErrorPath,
      0,
      0
    );

    this.logger.debug(`get login url request ${path}`, loginRequest);
    return http
      .post<LoginResponse>(path, loginRequest)
      .then((resp: LoginResponse) => {
        this.logger.debug("get login url response:", resp);
        return resp;
      });
  }

  // reCaptchaCheck(request: CaptchaRequest): Promise<string> {
  //   const path = `${config.beBaseUrl}/api/v1/captcha`;

  //   this.logger.debug(`Captcha request ${path}`, request);
  //   return http.post<string>(path, request).then((resp: string) => {
  //     this.logger.debug("Captcha response:", resp);
  //     return resp;
  //   });
  // }

  // signUp(request: SignUpRequest): Promise<SignUp> {
  //   const path = `${config.beBaseUrl}/api/v1/signup`;

  //   this.logger.debug(`signup request ${path}`, request);
  //   return http.post<SignUp>(path, request).then((resp: SignUp) => {
  //     this.logger.debug("signup response:", resp);
  //     return resp;
  //   });
  // }

  // searchSignUps(request: SignUpRequestFilter): Promise<PagedResult<SignUp>> {
  //   const path = `${config.beBaseUrl}/api/v1/user/signup/search`;

  //   this.logger.debug(`signup search request ${path}`, request);
  //   return http
  //     .post<PagedResult<SignUp>>(path, request)
  //     .then((resp: PagedResult<SignUp>) => {
  //       this.logger.debug("signup search response:", resp);
  //       return resp;
  //     });
  // }

  // acceptSignUp(hashId: string): Promise<SignUp> {
  //   const path = `${config.beBaseUrl}/api/v1/user/signup/${hashId}/accept`;
  //   this.logger.debug("accept signup request sent");
  //   return http.get<SignUp>(path).then((resp: SignUp) => {
  //     this.logger.debug("accept signup response:", resp);
  //     return resp;
  //   });
  // }

  // rejectSignUp(request: RejectSignUpRequest): Promise<SignUp> {
  //   const path = `${config.beBaseUrl}/api/v1/user/signup/reject`;
  //   this.logger.debug("reject signup request sent");
  //   return http.put<SignUp>(path, request).then((resp: SignUp) => {
  //     this.logger.debug("reject signup response:", resp);
  //     return resp;
  //   });
  // }

  //local login
  login(
    role: string,
    sessionToken: JwtToken,
    refreshToken: JwtToken,
    uiMode: string
  ): Promise<void> {
    return dataService.setSessionToken(sessionToken).then((_) => {
      return dataService.setRefreshToken(refreshToken).then((_) => {
        return dataService.setRole(role).then((_) => {
          return dataService.setUiMode(uiMode).then((_) => {
            return dataService.setLoginTs().then((_) => {
              this.logger.debug("logged in with ui-mode:", uiMode);
              this.logger.debug("logged in with role:", role);
              this.logger.debug("logged in with session-token:", sessionToken);
              this.logger.debug("logged in with login-timestamp:", dataService.getLoginTs());
            });
          });
        });
      });
    });
  }

  //local logout
  logout(): Promise<void> {
    return dataService.clear().then((_) => {
      this.logoutOnBackEnd();
      this.logger.debug("logged out");
    });
  }

  private logoutOnBackEnd(): Promise<string> {
    const path = `${config.beBaseUrl}/api/v1/logout`;
    this.logger.debug("log out on back end side");
    return http.get<string>(path).then((resp: any) => {
      this.logger.debug("log out response:", resp);
      return "sign out";
    });
  }

  getRole(): Promise<Role> {
    return dataService.getRole().then((role) => {
      this.logger.debug("fetched role:", role);
      return role;
    });
  }


  private logoutFromWeb(): Promise<void> {
    return dataService.clear().then((_) => {
      this.logger.debug("logged out from WEB because of unauthorized response");
      window.location.replace(config.feBaseUrl + "/login");
    });
  }

  private logoutFromWebView(): Promise<void> {
    return dataService.clear().then((_) => {
      this.logger.debug("logged out from WEB-VIEW because of unauthorized response");
      window.location.replace(config.feBaseUrl + WEB_VIEW_ERROR_PATH);
    });
  }

  private handleWebUnauthorizedResponse(responseStatus: number, error: any): Promise<any> {
    if (responseStatus === 401) {
      this.logoutFromWeb()
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }

  private refreshToken(uiMode: UiMode = UiMode.WebView): Promise<void> {
    const refreshUrl = `${config.beBaseUrl}/api/v1/login/refresh`;
    var defaultHeaders: any = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    const authHeaderName = config.authHeader;
    const req: AxiosRequestConfig = {
      method: 'put',
      url: refreshUrl,
      data: {},
    } as AxiosRequestConfig;
    return dataService
      .getRefreshToken()
      .then((token: AuthToken) => {
        if (token.tokenType instanceof EmptyToken) {
          return defaultHeaders;
        } else {
          defaultHeaders[authHeaderName] = token.token;
          return defaultHeaders;
        }
      })
      .then((headers: any) => {
        return { ...req, headers };
      })
      .then((requst: AxiosRequestConfig) => {
        return httpClient(requst)
          .then((response: AxiosResponse<any>) => {
            if (response.status === 200) {
              const validatedResponse: RcmdResponse<RefreshTokenResponse> = responseValidator.validate<RefreshTokenResponse>(
                response.data
              );
              if (validatedResponse.header.responseCode === 0) {
                const body = validatedResponse.body!;
                const role = body.role;
                const accessToken = body.accessToken;
                const refreshToken = body.refreshToken;
                const uiMode = body.uiMode;
                return this.login(role, accessToken, refreshToken, uiMode)
              } else {
                if (uiMode === UiMode.Web) {
                  return this.logoutFromWeb()
                } else if (uiMode === UiMode.WebView) {
                  return this.logoutFromWebView()
                } else {
                  return this.logoutFromWeb()
                }
              }
            } else {
              if (uiMode === UiMode.Web) {
                return this.logoutFromWeb()
              } else if (uiMode === UiMode.WebView) {
                return this.logoutFromWebView()
              } else {
                return this.logoutFromWeb()
              }
            }
          })
      })
  }

  private handleWebViewUnauthorizedResponse(
    responseStatus: number,
    npuErrorCode: number,
    error: any
  ): Promise<any> {
    const TokenHasBeenExpiredBackendCode = 233
    const RefreshTokenHasBeenExpiredBackendCode = 231
    if (responseStatus === 401 && npuErrorCode === TokenHasBeenExpiredBackendCode) {
      return this.refreshToken()
        .then(() => {
          this.redirectToMainPage();
        })
    } else if (responseStatus === 401 && npuErrorCode === RefreshTokenHasBeenExpiredBackendCode) {
      this.logoutFromWebView()
      return Promise.reject(error);
    } else if (responseStatus === 401) {
      this.logoutFromWebView()
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }

  private redirectToMainPage() {
    const role = dataService.getRoleSync()
    role === Role.Admin ?
      window.location.replace("/dashboard") :
      role === Role.User ?
        window.location.replace("/search") :
        window.location.replace("/account");
  }

  hanldeExpiredToken(
    axiosResponse: AxiosResponse<RcmdEmptyBody>,
    rcmdHeader: RcmdResponseHeader,
    error: any
  ): Promise<any> {
    this.logger.debug("======");
    this.logger.debug("AuthService.hanldeExpiredToken()...");
    const responseStatus = axiosResponse.status;
    const npuErrorCode = rcmdHeader.responseCode;
    const uiMode = dataService.getUiModeSync()
    if (uiMode === UiMode.Web) {
      return this.handleWebUnauthorizedResponse(responseStatus, error);
    } else if (uiMode === UiMode.WebView) {
      return this.handleWebViewUnauthorizedResponse(responseStatus, npuErrorCode, error);
    } else {
      return Promise.reject(error);
    }
  }

  isLoggedInSync(): boolean {
    const token: AuthToken = dataService.getSessionTokenSync();
    const role: Role = dataService.getRoleSync();
    if (
      token.tokenType instanceof EmptyToken ||
      role === Role.Empty ||
      role === Role.Unknown
    ) {
      this.logger.debug("(sync) user is not logged in");
      return false;
    } else {
      this.logger.debug("(sync) user logged in with role:", role);
      return true;
    }
  }

  isLoggedIn(): Promise<boolean> {
    return dataService.getSessionToken().then((token: AuthToken) => {
      return dataService.getRole().then((role: Role) => {
        if (
          token.tokenType instanceof EmptyToken ||
          role === Role.Empty ||
          role === Role.Unknown
        ) {
          this.logger.debug("user is not logged in");
          return false;
        } else {
          this.logger.debug("user logged in with role:", role);
          return true;
        }
      });
    });
  }
}

export const authService = new AuthService();
